import * as Models from "../../ts/rlAdmin.models";
import * as Consts from "../../ts/rlAdmin.consts";
import * as Utils from "../../ts/rlAdmin.utils";
import { AdminConfigService } from "../../services/admin-config-service";
import { AdminService } from "../../services/admin-service";
import { EntityService } from "../../services/entity-service";
import { ContactService } from "../../services/contact-service";
import { EntityConfigService } from "../../services/entity-config-service";
import { NotifyService } from "../../services/notify-service";
import { WorkflowService } from "../../services/workflow-service";
import { SearchService } from "../../services/search-service";
import { IdentityService } from "../../services/identity-service";

export class AdminController {
    static $inject = ["$scope", "$window", "$location", "$filter", "$q", "adminConfigService", "adminService",
        "entityService", "contactService", "entityConfigService", "notifyService",
        "workflowService", "searchService", "identityService", "$timeout"];

    createUserModal: boolean;
    createModal: boolean;
    createFromExisting: boolean;
    editUserModal: boolean;
    search: boolean;
    totalItems: number;
    currentPage: number;
    keywords: string;
    hideTemplate: boolean;

    users: Models.IAdvancedSearchModel;
    roles: Models.IAccountRole[];
    identityRoles: Models.IAspNetUserRole[];
    charTemplates: Models.IEntityCharTypeTemplate[];
    userRows: Models.IAspNetUser[];

    newUserInfo: Models.IRLUser;
    editUserInfo: Models.IRLUser;
    searchItemRows: any[];
    uniqueUserName: boolean;

    selectedRoles: { [key: string]: boolean };
    selectedRoleIDs: number[];
    selectedIdentityRoles: { [key: string]: boolean };
    selectedIdentityRoleIDs: number[];
    //groups: Models.IAccountGroup[];
    apiKey: Models.IApiKey[];
    selectedGroups: { [key: string]: boolean };
    selectedGroupIDs: number[];
    passwordReset: Models.IPasswordReset;

    employeeTemplateID: number;     // hard coded to only work with the internal employee template
    entityTemplateID: string;
    adminAppUrlType: number;
    appUrlID: number;
    numFound: number;
    selectedEmailInfo: Models.ICharDataCollection[];
    selectedTemplateID: number;

    divUsersSearchRequest: Models.IAdvancedSearchModel;
    userItemRows: any[];
    allUsers: any[];

    page: number;
    pageCount: number;
    rowCount: number;
    recordsPerPage: number[];

    templateFacets: Models.IKeyValuePair<string, string>[];
    statusFacets: Models.IKeyValuePair<string, string>[];
    applicationFacets: Models.IKeyValuePair<string, string>[];

    createOptionModal: boolean;
    createNewContact: boolean;
    createNewLoginForContact: boolean;
    contactTemplates: Models.IEntityCharTypeTemplate[];
    contactEntityCharDataCollection: Models.ICharDataCollection;
    contactTemplateID: string;
    editMode: boolean;
    visibility: boolean;
    showApplications: boolean;
    showRoles: boolean;

    appUrls: Models.IApplicationInfo[];
    selectedAppUrl: number;
    selectedAppUrls: { [key: string]: boolean };
    multiSelect: boolean;
    showAdvance: boolean;
    showColumns: boolean;
    canCreate: boolean;
    selectedRecIdTitlePairs: Models.IKeyValuePair<number, string>[];
    searchContact: boolean;
    allowExistingContactToLoginPermission: boolean;
    selectedStatus: string;                                     // current selected	status        
    selectedTemplate: string;                                   // current selected	template        
    userEmailRequired: boolean;
    userTitleRequired: boolean;
    createNewContactTitle: string;
    isRlUser: boolean;
    editRlUserID: number;
    identityRolesRequired: boolean;
    showWorkflowActionModal: boolean;
    selectedUserName: string;
    selectedUserEntityID: string;
    selectedUserTitle: string;
    selectedUserStatus: string;
    selectedUserStatusID: number;
    workflowActions: Models.IWFAction[];
    actionID: number;
    processID: number;
    showUserConflict: boolean;
    fromContactSecurityTab: boolean;

    constructor(
        private $scope: ng.IScope,
        private $window: ng.IWindowService,
        private $location: ng.ILocationService,
        private $filter: ng.IFilterService,
        private $q: ng.IQService,
        private adminConfigService: AdminConfigService,
        private adminService: AdminService,
        private entityService: EntityService,
        private contactService: ContactService,
        private entityConfigService: EntityConfigService,
        private notifyService: NotifyService,
        private workflowService: WorkflowService,
        private searchService: SearchService,
        private identityService: IdentityService,
        private $timeout: ng.ITimeoutService
    ) {

        this.createUserModal = false;
        this.createModal = false;
        this.createFromExisting = false;
        this.editUserModal = false;

        this.employeeTemplateID = 3;    // hard coded to only work with the internal employee template
        this.adminAppUrlType = 3;       //hard coded to only allow admin url type
        this.entityTemplateID = Utils.IdBuilder.buildTemplateID(0, Consts.CharTypeIDs.user, this.employeeTemplateID);
        this.appUrlID = 0;
        this.charTemplates = [];

        this.selectedEmailInfo = [];
        this.identityRoles = [];
        this.roles = [];
        this.search = false;
        this.numFound = 0;

        this.hideTemplate = false;
        this.uniqueUserName = true;
        this.totalItems = 10;
        this.currentPage = 1;
        this.keywords = "";
        this.selectedTemplateID = 0;
        this.page = 1;
        this.rowCount = 25;
        this.showApplications = false;
        this.showRoles = true;
        this.isRlUser = false;
        this.identityRolesRequired = true;

        this.divUsersSearchRequest = {
            charTypeID: 2,
            keywords: "",
            page: 1,
            relatedToMe: false,
            rowCount: this.rowCount,
            searchGroups: [],
            sortDir: 0,
            sortField: "",
            status: "",
            template: ""
        };

        this.recordsPerPage = [25, 50, 100, 200];
        this.createOptionModal = false;
        this.createNewContact = false;
        this.createNewLoginForContact = false;
        this.contactTemplates = [];
        this.editMode = false;
        this.visibility = false;
        this.appUrls = [];
        this.selectedAppUrls = {};
        this.selectedRoles = {};
        this.selectedIdentityRoles = {};
        this.multiSelect = false;
        this.showAdvance = false;
        this.showColumns = false;
        this.canCreate = false;
        this.selectedRecIdTitlePairs = [];
        this.searchContact = false;
        this.allowExistingContactToLoginPermission = false;
        this.userEmailRequired = false;
        this.userTitleRequired = false;
        this.createNewContactTitle = "";
        this.showWorkflowActionModal = false;
        this.workflowActions = [];
        this.selectedUserName = "";
        this.selectedUserEntityID = "";
        this.selectedUserTitle = "";
        this.selectedUserStatus = "";
        this.selectedUserStatusID = 0;
        this.actionID = 0;
        this.processID = 0;
        this.showUserConflict = false;
        this.fromContactSecurityTab = false;

        $scope.$watch(() => this.selectedAppUrl, (newValue, oldValue) => {
            if (newValue != oldValue) {
                this.divUsersSearchRequest.facetFields = [];
                var selectedAppUrl = _.find(this.appUrls, a => a.appUrlID == newValue);
                if (selectedAppUrl != null) {
                    var appUrlMeta: string = selectedAppUrl.label + "|" + newValue;
                    this.divUsersSearchRequest.facetFields.push(appUrlMeta);
                }
                else {
                    this.divUsersSearchRequest.facetFields = [];
                }
                this.divUsersSearchRequest.template = "";
                this.divUsersSearchRequest.status = "";
                this.divUsersSearchRequest.page = 1;
                this.GetDivUsers();
            }
        });

        $scope.$watchCollection(() => [this.selectedTemplate, this.selectedStatus, this.rowCount], (newValue, oldValue) => {
            if (newValue != oldValue) {
                this.divUsersSearchRequest.template = this.selectedTemplate;
                this.divUsersSearchRequest.status = this.selectedStatus;
                this.divUsersSearchRequest.rowCount = this.rowCount;
                this.divUsersSearchRequest.page = 1;
                this.GetDivUsers();
            }
        });

        $scope.$watch(() => this.page, (newValue, oldValue) => {
            if (newValue != oldValue && newValue > 1) {
                this.divUsersSearchRequest.page = newValue;
                this.GetDivUsers();
            }
        });

        $scope.$watch(() => this.searchContact, (newValue, oldValue) => {
            if (!newValue && newValue != oldValue) {
                this.AllowExistingContactToLoginPermission();
            }
        });
    }

    Init(contactRecordID: number) {
        this.notifyService.startProgress();
        var promise = this.adminService.getUserList(this.divUsersSearchRequest).then((result) => {
            this.userItemRows = result.documents;
            this.allUsers = _.cloneDeep(this.userItemRows);
            this.numFound = result.numFound;
            this.pageCount = Math.ceil(this.numFound / this.rowCount);
            this.templateFacets = result.getTemplateFacets();
            this.statusFacets = result.getStatusFacets();
            this.recordsPerPage.push(this.numFound);
        });

        var promise1 = this.contactService.getApplicationList()
            .then((result) => {
                this.appUrlID = _.find(result, (app) => app.urlTypeID == this.adminAppUrlType).appUrlID;
                this.appUrls = result;
                if (this.appUrls.length > 1) {
                    this.showApplications = true;
                }
            });

        var promise2 = this.contactService.getUserRoles()
            .then((result) => {
                this.roles = result;
            });

        var promise3 = this.contactService.getRoleList()
            .then((result) => {
                this.identityRoles = result
            });

        var charType = "2";
        var promise4 = this.adminConfigService.GetCharTypeTemplate(charType, "true")
            .then((result) => {
                this.contactTemplates = result;
            });

        var promise5 = this.adminConfigService.isRLUser()
            .then((result) => {
                if (result.success && result.data) {
                    this.isRlUser = true;
                }
                else {
                    this.isRlUser = false;
                }
            });

        this.$q.all([promise, promise1, promise2, promise3, promise4, promise5])
            .then(() => {
                this.notifyService.endProgress();
                if (contactRecordID > 0) {
                    var contactEntityID = Utils.IdBuilder.buildEntityID(0, Consts.CharTypeIDs.user, contactRecordID);
                    this.fromContactSecurityTab = true;
                    this.Edit(contactEntityID);
                }
            });
    }

    GetAppUrls() {
        return this.contactService.getApplicationList()
            .then((result) => {
                this.appUrlID = _.find(result, (app) => app.urlTypeID == this.adminAppUrlType).appUrlID;
                this.appUrls = result;
                if (this.appUrls.length > 1) {
                    this.showApplications = true;
                }
            });
    }

    GetUserRoles() {
        return this.contactService.getUserRoles()
            .then((result) => {
                this.roles = result;
            });
    }

    GetIdentityRoles() {
        return this.contactService.getRoleList()
            .then((result) => {
                this.identityRoles = result
            });
    }

    GetDivUsers() {
        this.notifyService.startProgress();
        return this.adminService.getUserList(this.divUsersSearchRequest)
            .then((result) => {
                this.userItemRows = result.documents;
                this.numFound = result.numFound;
                this.pageCount = Math.ceil(this.numFound / this.rowCount);
                this.templateFacets = result.getTemplateFacets();
                this.statusFacets = result.getStatusFacets();
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    SearchUsers(keywords: string) {
        this.keywords = keywords;
        this.divUsersSearchRequest.keywords = keywords;
        this.GetDivUsers();
    }

    Edit(contactEntityID: string) {
        this.entityService.getEntity(contactEntityID)
            .then((result) => {
                contactEntityID = result.record.id;
                var contactRecordID = Utils.IdBuilder.splitEntityID(contactEntityID).recID;
                this.selectedTemplateID = result.record.templateID;
                var userEntityCharData = result.charDataCollection;
                this.allowExistingContactToLoginPermission = _.any<Models.ICharacteristicMetaData>(result.charDataCollection.templateMetaData.characteristicMetaDatas, (cmd) => { return cmd.tagLabel == "email"; })
                if (this.allowExistingContactToLoginPermission) {
                    var roles: Models.IAccountRole[];
                    var identityRoles: Models.IAspNetUserRole[];
                    var appUrls: Models.IApplicationInfo[];
                    this.showUserConflict = false;
                    this.notifyService.startProgress();
                    var promise1 = this.contactService.getUserSecurityInfo(result.record.id)
                        .then((result) => {
                            roles = _.filter(this.roles, (role) => _.any(result.roles, (role2) => role.roleID == role2.roleID));
                            appUrls = _.filter(this.appUrls, (appUrl) => _.any(result.applications, (appUrl2) => appUrl.appUrlID == appUrl2.appUrlID));
                        });

                    var promise2 = this.identityService.getUserRoles(contactRecordID)
                        .then((result) => identityRoles = result);

                    var userEmail: string = "";
                    var userTitle: string = "";

                    if (userEntityCharData.charDatas['email'].length > 0) {
                        userEmail = userEntityCharData.charDatas['email'][0].value;
                    }
                    if (userEntityCharData.charDatas['entity_title'].length > 0) {
                        userTitle = userEntityCharData.charDatas['entity_title'][0].value;
                    }

                    var promise3 = this.adminConfigService.ShowUserConflictMessageForContact(userEmail, contactRecordID)
                        .then((result) => {
                            if (result.data && this.fromContactSecurityTab) {
                                this.showUserConflict = true;
                            }
                            else {
                                this.showUserConflict = false;
                            }
                        });

                    this.$q.all([promise1, promise2, promise3])
                        .then((res) => {
                            var isAdminAppSelected: boolean = _.any(appUrls, a => a.appUrlID == this.appUrlID);
                            //if (isAdminAppSelected) {
                            //    this.identityRolesRequired = true;
                            //}
                            //else {
                            //    this.identityRolesRequired = false;
                            //}

                            if (_.isEmpty(userEmail)) {
                                this.userEmailRequired = true;
                            }

                            if (_.isEmpty(userTitle) || userTitle == '') {
                                this.userTitleRequired = true;
                            }

                            this.editUserInfo = {
                                entityID: contactEntityID,
                                email: userEmail,
                                name: userTitle,
                                selectedAppUrls: appUrls,
                                selectedRoles: roles,
                                selectedIdentityRoles: identityRoles,
                                selectedTemplate: 0
                            };

                            if (this.showUserConflict) {
                                var conflictMessage = "A login user with the same email address already exists in another Rightsline application, so the Contact record you have selected cannot be promoted to a login user role. If you want to grant " + userEmail + " access to this application, another Contact record will get created in the process. You may want to clean up after, by deleting the Contact record you just selected";
                                if (!this.$window.confirm(conflictMessage)) {
                                    this.editUserModal = false;
                                }
                                else {
                                    this.editUserModal = true;
                                }
                            }
                            else {
                                this.editUserModal = true;
                            }
                        })
                        .finally(() => {
                            this.fromContactSecurityTab = false;
                            this.notifyService.endProgress();
                        });
                }
                else {
                    alert("Selected Contact does not have required fields to be created as Application Login User.");
                }
            });
    }

    EditExisting(user: Models.IRLUser) {
        var roles: Models.IAccountRole[];
        var identityRoles: Models.IAspNetUserRole[];
        var appUrls: Models.IApplicationInfo[];

        var promise1 = this.contactService.getUserSecurityInfo(user.entityID)
            .then((result) => {
                roles = _.filter(this.roles, (role) => _.any(result.roles, (role2) => role.roleID == role2.roleID));
            });
        var promise2 = this.identityService.getUserRoles(Utils.IdBuilder.splitEntityID(user.entityID).recID)
            .then((result) => identityRoles = result);

        this.$q.all([promise1, promise2])
            .then((res) => {
                this.editUserInfo = {
                    entityID: user.entityID,
                    email: user.email,
                    name: "",
                    selectedAppUrls: appUrls,
                    selectedRoles: roles,
                    selectedIdentityRoles: identityRoles,
                    selectedTemplate: 0
                };
                this.editUserModal = true;
            });
    }

    setContact(recordID: number) {
        var newEmail = this.searchItemRows.filter(s => s.recordID == recordID)
        var record = newEmail[0];
        this.newUserInfo.entityID = recordID.toString();
        this.hideTemplate = true;

        this.entityService.getEntityCharDatas(record.divisionID, record.charTypeID, record.recordID).then((result) => {
            this.newUserInfo.email = result[0].charDatas['email'][0].value;
            this.newUserInfo.selectedTemplate = result[0].templateMetaData.templateID;
            this.newUserInfo.name = record.title;
            this.newUserInfo.entityID = result[0].entityID;

            this.adminConfigService.IsUserAppUser(this.newUserInfo.email).then((result) => {
                if (result.success) {
                    this.createModal = false;
                    this.EditExisting(this.newUserInfo);
                }
            });
        });
    }

    SaveEdit(isValid: boolean, user: Models.IRLUser) {
        if (isValid) {
            if (user.selectedAppUrls) {
                var appUrlIDs = user.selectedAppUrls.map((appUrl) => {
                    return appUrl.appUrlID;
                });
            }

            if (user.selectedRoles) {
                var roleIDs = user.selectedRoles.map((role) => {
                    return role.roleID;
                });
            }

            if (user.selectedIdentityRoles) {
                var identityRoleIDs = user.selectedIdentityRoles.map((role) => {
                    return role.roleID;
                });
            }

            this.notifyService.startProgress();
            this.adminService.updateUserSecurity(user.entityID, user.email, appUrlIDs, roleIDs, identityRoleIDs)
                .then((result) => {
                    if (result.data) {
                        this.notifyService.notifySuccess("Security Updated");
                    }
                    else {
                        this.notifyService.notifyError("Error updating security for user");
                    }
                }, this.notifyService.errorResponseHandler)
                .finally(() => {
                    this.editUserModal = false;
                    this.fromContactSecurityTab = false;
                    this.notifyService.endProgress();
                });
        }
    }

    Reset(userRecordID: number, userEmail: string) {
        if (this.$window.confirm("This will reset this user's current password and send them a new link to login. Are you sure you wish to proceed?")) {
            this.notifyService.startProgress();
            this.adminService.passwordReset(userRecordID, userEmail)
                .then((result) => {
                    if (result.data) {
                        this.notifyService.notifySuccess("Password Reset Email Sent");
                    }
                    else {
                        this.notifyService.notifyError("Error processing password reset");
                    }
                }).finally(() => {
                    this.notifyService.endProgress();
                });
        }
    }

    Delete(entityID: string) {
        if (this.$window.confirm("Are you sure you want to delete this user?")) {
            this.adminService.deleteUser(entityID)
                .then((result) => {
                    if (result.data) {
                        this.notifyService.notifySuccess("Successfully Deleted User");
                    }
                    else {
                        this.notifyService.notifyError("Error Deleting User");
                    }
                    this.$timeout(() => {
                        this.GetDivUsers()
                            .then(() => {
                                this.notifyService.endProgress();
                            });
                    }, 1000);
                });
        }
    }

    SendInvitationEmail(isValid: boolean, user: Models.IRLUser) {
        if (!isValid) {
            this.notifyService.notifyError("Correct Errors");
        }
        else {
            this.notifyService.startProgress();

            if (user.selectedAppUrls) {
                var appUrlIDs = user.selectedAppUrls.map((appUrl) => {
                    return appUrl.appUrlID;
                });
            }

            if (user.selectedRoles) {
                var roleIDs = user.selectedRoles.map((role) => {
                    return role.roleID;
                });
            }

            if (user.selectedIdentityRoles) {
                var identityRoleIDs = user.selectedIdentityRoles.map((role) => {
                    return role.roleID;
                });
            }

            this.adminConfigService.IsEmailValidForAppLogin(user.email)
                .then((result) => {
                    if (result.data) {
                        return this.adminService.inviteNewUser(user.entityID, user.email, user.name, this.selectedTemplateID, appUrlIDs, roleIDs, identityRoleIDs)
                            .then((result) => {
                                if (result.success) {
                                    user.entityID = result.entityID;
                                    this.notifyService.notifySuccess("Contact Created!");
                                } else {
                                    this.notifyService.notifyError("There was an error creating your contact.");
                                }
                            }, () => {
                                this.notifyService.notifyError("There was an error creating your contact.");
                            })
                            .finally(() => {
                                this.newUserInfo = undefined;
                                this.editUserInfo = undefined;
                                this.createUserModal = false;
                                this.createOptionModal = false;
                                this.createNewContact = false;
                                this.createNewLoginForContact = false;
                                this.searchContact = false;
                                this.editUserModal = false;
                            });
                    }
                    else {
                        alert("This email address is already attached to a different Login for this Div. Please choose a valid different email address");
                    }
                })
                .then(() => {
                    return this.GetDivUsers();
                })
                .finally(() => {
                    this.notifyService.endProgress();
                });
        }
    }

    CreateNewOptions() {
        this.createOptionModal = true;
        //this.identityRolesRequired = false;
        this.selectedRecIdTitlePairs = [];
    }

    CreateNewContact(template: Models.ICharacteristicTemplate, $event: ng.IAngularEvent) {
        this.createOptionModal = false;
        this.createNewContact = true;
        this.createNewLoginForContact = false;
        this.selectedTemplateID = template.templateID;
        this.newUserInfo = {
            entityID: "",
            email: "",
            name: "",
            selectedAppUrls: [],
            selectedRoles: [],
            selectedIdentityRoles: [],
            selectedTemplate: this.selectedTemplateID
        };
        this.createNewContactTitle = "Create new Contact and Application User";
    }

    CreateNewLoginFromContact() {
        this.selectedRecIdTitlePairs = [];
        this.createOptionModal = false;
        this.createNewContact = false;
        this.searchContact = true;
    }

    AllowExistingContactToLoginPermission() {
        var selectedContactRecID = this.selectedRecIdTitlePairs[0].key;
        var selectedContactEntityID = Utils.IdBuilder.buildEntityID(0, Consts.CharTypeIDs.user, selectedContactRecID);
        this.allowExistingContactToLoginPermission = false;
        this.userTitleRequired = false;
        this.showUserConflict = false;
        this.notifyService.startProgress();
        var showCreateAppUserModal: boolean = false;
        this.entityService.getEntity(selectedContactEntityID)
            .then((result) => {
                this.selectedTemplateID = result.record.templateID;
                this.allowExistingContactToLoginPermission = _.any<Models.ICharacteristicMetaData>(result.charDataCollection.templateMetaData.characteristicMetaDatas, (cmd) => { return cmd.tagLabel == "email"; })
                if (this.allowExistingContactToLoginPermission) {
                    var userEmailChars = result.charDataCollection.charDatas["email"];
                    var userEmail: string = "";

                    if (userEmailChars.length > 0) {
                        userEmail = userEmailChars[0].value;
                    }
                    else {
                        this.userEmailRequired = true;
                    }

                    if (_.isEmpty(result.record.title) || result.record.title != '') {
                        this.userTitleRequired = true;
                    }

                    this.newUserInfo = {
                        entityID: result.record.id,
                        email: userEmail,
                        name: result.record.title,
                        selectedAppUrls: [],
                        selectedRoles: [],
                        selectedIdentityRoles: [],
                        selectedTemplate: 0
                    };
                    this.createNewContactTitle = "Create Application User for Existing Contact";
                    showCreateAppUserModal = true;
                    this.editMode = false;
                }
                else {
                    alert("Selected Contact does not have required fields to be created as Application Login User.");
                }
                this.notifyService.endProgress();
            })
            .finally(() => {
                this.notifyService.endProgress();
                if (!this.userEmailRequired) {
                    this.adminConfigService.ShowUserConflictMessageForContact(this.newUserInfo.email, selectedContactRecID)
                        .then((result) => {
                            if (result.data) {
                                this.showUserConflict = true;
                            }
                            else {
                                this.showUserConflict = false;
                            }
                        })
                        .finally(() => {
                            if (this.showUserConflict) {
                                var conflictMessage = "A login user with the same email address already exists in another Rightsline application, so the Contact record you have selected cannot be promoted to a login user role. If you want to grant " + this.newUserInfo.email + " access to this application, another Contact record will get created in the process. You may want to clean up after, by deleting the Contact record you just selected";
                                if (!this.$window.confirm(conflictMessage)) {
                                    this.createNewContact = false;
                                }
                                else {
                                    this.createNewContact = true;
                                }
                            }
                            else {
                                if (showCreateAppUserModal) {
                                    this.createNewContact = true;
                                }
                            }
                        });
                }
                else {
                    this.createNewContact = true;
                }
                this.selectedRecIdTitlePairs = [];
            });
    }

    EditRLUser() {
        var rlUserEntity = Utils.IdBuilder.buildEntityID(0, Consts.CharTypeIDs.user, this.editRlUserID);
        this.Edit(rlUserEntity);
    }

    ApplicationSelected(user: Models.IRLUser) {
        var isAdminAppSelected: boolean = _.any(user.selectedAppUrls, a => a.appUrlID == this.appUrlID);
        if (isAdminAppSelected) {
            //this.identityRolesRequired = true;
        }
        else {
            //this.identityRolesRequired = false;
            user.selectedIdentityRoles = [];
        }
    }

    ShowWorkflowActionModal(userDocument: any) {
        //var userDocument = _.find(this.userItemRows, u => u.entityID == userEntityID);
        if (userDocument != null) {
            this.selectedUserEntityID = userDocument.entityID;
            this.selectedUserName = userDocument.characteristics.email;
            this.selectedUserTitle = userDocument.title;
            this.selectedUserStatus = userDocument.status;
            this.selectedUserStatusID = userDocument.statusID;

            if (this.selectedUserStatusID > 0) {
                this.notifyService.startProgress();
                this.workflowService.getAvailableWorkflowActions(Consts.CharTypeIDs.user, userDocument.templateID, this.selectedUserStatusID)
                    .then((result) => {
                        this.workflowActions = result;
                        if (this.workflowActions.length > 0) {
                            this.processID = this.workflowActions[0].processID;
                            this.showWorkflowActionModal = true;
                        }
                        else {
                            alert("There are no Workflow Actions available for you to perform for this User.");
                        }
                        this.notifyService.endProgress();
                    });
            }
        }
        else {
            alert("Could not find user");
            this.showWorkflowActionModal = true;
        }
    }

    ExecuteWorkflow() {
        var batchID: string = '';
        this.notifyService.startProgress();
        this.workflowService.createBatchID()
            .then((batchIDResult) => {
                batchID = batchIDResult.batchID;
                var recordID = Utils.IdBuilder.splitEntityID(this.selectedUserEntityID).recID;
                var recIDs: number[] = [];
                recIDs.push(recordID);
                return this.workflowService.executeWorkflow(Consts.CharTypeIDs.user, recIDs, this.actionID, this.processID, batchID)
                    .then((result) => {
                        if (result.success) {
                            this.notifyService.notifySuccess("Workflow Action Successful.");
                        }
                        else {
                            this.notifyService.notifyError("Workflow Action Failed.");
                        }
                    });
            }).finally(() => {
                this.selectedUserEntityID = "";
                this.selectedUserName = "";
                this.selectedUserTitle = "";
                this.selectedUserStatus = "";
                this.selectedUserStatusID = 0;
                this.workflowActions = [];
                this.showWorkflowActionModal = false;
                this.notifyService.endProgress();
                this.GetDivUsers();
            });
    }
}
